export enum PlatformUserRoles {
  Owner = 'Owner',
  Admin = 'Admin',
  FinancialAdmin = 'FinancialAdmin',
  CustomerSupport = 'CustomerSupport',
  Auditor = 'Auditor',
}
